import type { Address } from 'viem'

import type { SwapParameters } from '../sdk'

/** +10% gas margin (equivalente a calculateGasMargin de ethers). */
export function calculateGasMarginViem(gas: bigint): bigint {
  return (gas * 11000n) / 10000n
}

function asAddr(a: string): Address {
  return a as Address
}

function hexToBigInt(h: string): bigint {
  return BigInt(h)
}

/**
 * Convierte `Router.swapCallParameters` (args en hex como produce el SDK) al tuple que espera viem/wagmi.
 */
export function swapParametersToViemArgs(
  methodName: SwapParameters['methodName'],
  args: SwapParameters['args'],
): readonly unknown[] {
  switch (methodName) {
    case 'swapExactETHForTokens':
    case 'swapExactETHForTokensSupportingFeeOnTransferTokens': {
      const [amountOutMin, path, to, deadline] = args
      return [
        hexToBigInt(amountOutMin as string),
        (path as string[]).map(asAddr),
        asAddr(to as string),
        hexToBigInt(deadline as string),
      ]
    }
    case 'swapExactTokensForETH':
    case 'swapExactTokensForETHSupportingFeeOnTransferTokens':
    case 'swapExactTokensForTokens':
    case 'swapExactTokensForTokensSupportingFeeOnTransferTokens': {
      const [amountIn, amountOutMin, path, to, deadline] = args
      return [
        hexToBigInt(amountIn as string),
        hexToBigInt(amountOutMin as string),
        (path as string[]).map(asAddr),
        asAddr(to as string),
        hexToBigInt(deadline as string),
      ]
    }
    case 'swapETHForExactTokens': {
      const [amountOut, path, to, deadline] = args
      return [
        hexToBigInt(amountOut as string),
        (path as string[]).map(asAddr),
        asAddr(to as string),
        hexToBigInt(deadline as string),
      ]
    }
    case 'swapTokensForExactETH':
    case 'swapTokensForExactTokens': {
      const [amountOut, amountInMax, path, to, deadline] = args
      return [
        hexToBigInt(amountOut as string),
        hexToBigInt(amountInMax as string),
        (path as string[]).map(asAddr),
        asAddr(to as string),
        hexToBigInt(deadline as string),
      ]
    }
    default:
      throw new Error(`swapParametersToViemArgs: método no soportado: ${methodName}`)
  }
}

export function swapValueToWei(valueHex: string): bigint {
  if (!valueHex || valueHex === '0x0' || valueHex === '0x') return 0n
  return BigInt(valueHex)
}
